import {Component, HostListener, OnInit} from '@angular/core';
import {AssetRepresentation} from '../../model/asset-representation';
import {Tenant} from '../../model/tenant';
import {BasicFilters} from '../../model/filters/basic-filters';
import {AssetRepresentationsService} from '../../services/asset-representations.service';
import {TenantsService} from '../../services/tenants.service';
import {AuthGuard} from '../../common/auth-guard.service';
import {CommonMessagesService} from '../../services/common-messages.service';
import {SortOrder} from '../../model/sort-order';
import {FiltersService} from '../../services/filters.service';

@Component({
  selector: 'app-asset-representations',
  templateUrl: './asset-representations.component.html',
  styleUrls: ['./asset-representations.component.scss']
})
export class AssetRepresentationsComponent implements OnInit {

  public representations: AssetRepresentation[];
  public totalRepresentations: number;
  public loadingRepresentations: boolean;
  public tenants: Tenant[];

  public rows = 10;
  public first = 0;
  public selected = [];

  public filtersVisible: boolean;
  public currentFilters: BasicFilters;
  public displayFailedDeleteList: boolean;
  public failedDeleteList: any[];
  public filtersFilled: boolean;

  constructor(private assetRepresentationsService: AssetRepresentationsService,
              private tenantsService: TenantsService,
              public authGuardService: AuthGuard,
              private commonMessagesService: CommonMessagesService,
              private filtersService: FiltersService<BasicFilters>) {
    this.currentFilters = new BasicFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    this.representations = new Array(this.rows);
    if (this.authGuardService.superAdminRequired()) {
      this.tenantsService.getTenants().subscribe(response => {
        response.tenants.sort((a, b) => a.name > b.name ? 1 : -1);
        this.tenants = response.tenants;
        Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
      });
    } else {
      Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
    }
  }

  private loadRepresentations(offset: number, limit: number): void {
    this.loadingRepresentations = true;
    this.representations = new Array(this.rows);
    this.assetRepresentationsService.getAssetRepresentations(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters : this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.representations = response.assetRepresentations;
        this.totalRepresentations = response.totalElements;
        this.loadingRepresentations = false;
      });
  }

  onPageChange(event: any): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadRepresentations(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new BasicFilters();
    this.currentFilters.sortField = 'name';
    this.currentFilters.sortOrder = SortOrder.ASCENDING;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true) {
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadRepresentations(this.first / this.rows, this.rows);
  }

  confirmAndDelete(representation: AssetRepresentation): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.deleteRepresentation(representation.tenant.uuid, representation.name);
    });
  }

  deleteRepresentation(tenantUuid: string, name: string): void {
    this.tenantsService.deleteTenantAssetRepresentation(tenantUuid, name).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadRepresentations(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  confirmAndDeleteSelected(): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(), true);
  }

  deleteSelected(): void {
    if (this.selected.length === 0) {
      return;
    }
    const identifiers = this.selected.map(item => ({tenantUuid: item.tenant.uuid, name: item.name}));

    this.assetRepresentationsService.deleteAssetRepresentations(identifiers).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadRepresentations(this.first / this.rows, this.rows);
    }, error => {
      this.failedDeleteList = error.error.representationsBeingUsed;
      this.displayFailedDeleteList = true;
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status, true);
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

}
